import { Box, Dialog, DialogContent, Radio, Stack, Switch, Typography } from '@mui/material'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { observer } from 'mobx-react-lite'
import StoreGenealogyFilter from './StoreGenealogyFilter'
import styled from '@emotion/styled'
import { ReactComponent as RefreshIcon } from './assets/RefreshIcon.svg'
import { ReactComponent as TreeViewIcon } from './assets/TreeViewIcon.svg'
import { ReactComponent as CloseIcon } from './assets/CloseIcon.svg'
import { runInAction } from 'mobx'

const GenealogyFilterSwitch = styled(Switch)(() => ({
    padding: 8,
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        backgroundColor: '#9EA9B9',
        opacity: 1
    },
    '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
            '& + .MuiSwitch-track': {
                backgroundColor: '#6FCF97',
                opacity: 1
            }
        }
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
        backgroundColor: '#FFFFFF'
    }
}))

const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 16,
    height: 16,
    backgroundColor: '#9EA9B9',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2
    }
}))

const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#6FCF97',
    backgroundImage: 'linear-gradient(180deg,#6FCF97,#6FCF97)',
    '&::before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""'
    },
    'input:hover ~ &': {
        backgroundColor: '#6FCF97'
    },
    boxShadow: 'none'
})

function GenealogyFilterRadio(props) {
    return <Radio disableRipple color="default" checkedIcon={<BpCheckedIcon />} icon={<BpIcon />} {...props} />
}

const GenealogyFilterModal = observer(props => {
    const translate = useTranslate()
    const refreshGenealogy = () => {
        StoreGenealogyFilter.triggerRefresh()
    }
    const historyGenealogy = () => {
        StoreGenealogyFilter.openHistoryModal()
    }

    return (
        <Dialog
            open={StoreGenealogyFilter.getShowFilterModal()}
            disableEscapeKeyDown
            sx={{
                '& .MuiDialog-paper': {
                    width: '100%',
                    maxWidth: '400px',
                    borderRadius: '8px'
                },
                '& .MuiBackdrop-root': {
                    pointerEvents: 'none'
                }
            }}>
            <DialogContent sx={{ padding: '0px!important' }}>
                <Stack>
                    <Stack
                        bgcolor={'#E3E7EC'}
                        padding={'15px 20px'}
                        position={'relative'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        direction={'row'}>
                        <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'} textTransform={'uppercase'}>
                            {translate('option')}
                        </Typography>
                        <Box
                            onClick={() => StoreGenealogyFilter.closeAndRefetch()}
                            display={'flex'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            sx={{ cursor: 'pointer' }}>
                            <CloseIcon />
                        </Box>
                    </Stack>
                    <Stack padding={'20px 42px'} gap={'0px'}>
                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'}>
                                {translate('hide_inactive_legs')}
                            </Typography>
                            <GenealogyFilterSwitch
                                checked={StoreGenealogyFilter.hideInactiveLegs}
                                onChange={() =>
                                    runInAction(() => {
                                        StoreGenealogyFilter.hideInactiveLegs = !StoreGenealogyFilter.hideInactiveLegs
                                        StoreGenealogyFilter.setDirty(true)
                                    })
                                }
                            />
                        </Stack>
                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'}>
                                {translate('sort_by_ov')}
                            </Typography>
                            <GenealogyFilterSwitch
                                checked={StoreGenealogyFilter.sortByOv}
                                onChange={() =>
                                    runInAction(() => {
                                        StoreGenealogyFilter.sortByOv = !StoreGenealogyFilter.sortByOv
                                        StoreGenealogyFilter.setDirty(true)
                                    })
                                }
                            />
                        </Stack>
                    </Stack>
                </Stack>
                <Stack>
                    <Stack bgcolor={'#E3E7EC'} padding={'15px 20px'}>
                        <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'} textTransform={'uppercase'}>
                            {translate('filter')}
                        </Typography>
                    </Stack>
                    <Stack padding={'20px 42px'} gap={'10px'}>
                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'}>
                                {translate('show_all_ba_type')}
                            </Typography>
                            <GenealogyFilterRadio
                                checked={StoreGenealogyFilter.getFilterOptions('showAll')}
                                onChange={() =>
                                    runInAction(() => {
                                        StoreGenealogyFilter.setFilterOptions({ showAll: !StoreGenealogyFilter.getFilterOptions('showAll') })
                                    })
                                }
                            />
                        </Stack>
                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'}>
                                {translate('show_distributors')}
                            </Typography>
                            <GenealogyFilterRadio
                                checked={StoreGenealogyFilter.getFilterOptions('showDistributor')}
                                onChange={() =>
                                    runInAction(() => {
                                        StoreGenealogyFilter.setFilterOptions({ showDistributor: !StoreGenealogyFilter.getFilterOptions('showDistributor') })
                                    })
                                }
                            />
                        </Stack>
                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'}>
                                {translate('show_member')}
                            </Typography>
                            <GenealogyFilterRadio
                                checked={StoreGenealogyFilter.getFilterOptions('showMember')}
                                onChange={() =>
                                    runInAction(() => {
                                        StoreGenealogyFilter.setFilterOptions({ showMember: !StoreGenealogyFilter.getFilterOptions('showMember') })
                                    })
                                }
                            />
                        </Stack>
                    </Stack>
                </Stack>
                <Stack>
                    <Stack bgcolor={'#E3E7EC'} padding={'15px 20px'}>
                        <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'} textTransform={'uppercase'}>
                            {translate('tools')}
                        </Typography>
                    </Stack>
                    <Stack>
                        <Stack
                            direction={'row'}
                            alignItems={'center'}
                            gap={'20px'}
                            padding={'15px 42px'}
                            borderBottom={'1px solid #E3E7EC'}
                            onClick={() => refreshGenealogy()}
                            sx={{
                                cursor: 'pointer'
                            }}>
                            <RefreshIcon />
                            <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'}>
                                {translate('refresh')}
                            </Typography>
                        </Stack>
                        <Stack
                            direction={'row'}
                            alignItems={'center'}
                            gap={'20px'}
                            padding={'15px 42px'}
                            onClick={() => historyGenealogy()}
                            sx={{
                                cursor: 'pointer'
                            }}>
                            <TreeViewIcon />
                            <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={400} color={'#384250'}>
                                {translate('history')}
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    )
})

export default GenealogyFilterModal
